module.exports = __webpack_public_path__ + "static/media/DSCF0069.de9451a9.jpg";